import Socials from "./socials";

const MobileFooter = () => (
  <footer className="mobile-footer">
    <Socials />
  </footer>
);

export default MobileFooter;
